module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', [(_vm.companies) ? _c('div', [_c('p', {
    staticClass: "sub-title-list"
  }, [_vm._v("Contas")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.companies) ? _c('li', [_c('a', {
      class: {
        active: company.moveMaisId == _vm.currentUser.moveMaisId
      },
      on: {
        "click": function($event) {
          return _vm.changeUser(company.moveMaisId)
        }
      }
    }, [_c('div', {
      staticClass: "dot"
    }), _vm._v("\n            " + _vm._s(company.companyName) + "\n          ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.companies) ? _c('div', {
    staticStyle: {
      "border-bottom": "3px solid #eeeeee",
      "margin": "10px -10px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.companies) ? _c('div', [_c('p', {
    staticClass: "sub-title-list"
  }, [_vm._v("Mais opções")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'plans'
      }
    }
  }, [_c('i', {
    staticClass: "icon-padnote"
  }), _vm._v("\n            Meus planos\n          ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'requests'
      }
    }
  }, [_c('i', {
    staticClass: "icon-tick-box"
  }), _vm._v("\n            Pedidos\n          ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "icon-avatar"
  }), _vm._v("\n            Meus dados\n          ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'password-change'
      }
    }
  }, [_c('i', {
    staticClass: "icon-key"
  }), _vm._v("\n            Alterar senha\n          ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v("\n            Sair\n          ")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Minha Conta")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-8f2892d2!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/my-account.vue
// module id = 2190
// module chunks = 1